import React, {useEffect, useState} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Dropdown from "react-bootstrap/Dropdown";
import {capitalizeFirst, objectMap} from "../../../javascripts/utils";
import { postingResponse, commentIcon } from "../../utils/postingHelpers";
import { copyToClipboard } from "../../utils/utilsHelpers";
import Share from "../actions/Share";
import Follow from "../actions/Follow";
import Like from "../actions/Like";
import ReportContent from "../actions/ReportContent";
import PostingAdminMenu from "./PostingAdminMenu";

export default function PostingActions(props) {
    let {
        posting,
        type,
        currentUser={},
        showCommentLink=true,
        commentIsOpen=false,
        showFollow=false,
        showLikes=true,
        hoverBg='white',
        condenseOnMobile=true,
        token,
        gtmEventRegion='',
        toggleRegistration=()=>{},
        leadData={}
    } = props;

    const [showCommentForm, setShowCommentForm] = useState(commentIsOpen);

    // Also in props: onToggleCommentForm

    const userSignedIn = !!currentUser;
    const viewingSelf = userSignedIn && currentUser.id == posting.author.id;
    const adminUser = userSignedIn && currentUser.admin;

    useEffect(() => {
        if (userSignedIn) {
            props.onToggleCommentForm(showCommentForm);
        }
    }, [showCommentForm]);

    // render functions

    const renderCommentLink = () => {
        if(showCommentLink) {
            const gtmDataAttributes = gtmEventRegion ? {
                'data-gtm-event-region': gtmEventRegion,
                'data-gtm-event-element': 'comment'} : {}

            return (
                <Col xs={'auto'} className={'py-2 px-0 pe-sm-2'}>
                    <a
                        {...gtmDataAttributes}
                        aria-expanded={showCommentForm}
                        aria-controls={'toggleAnswerForm'}
                        role="link"
                        data-after-signin-redirect={posting.actions.url}
                        data-external-only={1}
                        className={`p-2 link-secondary font-14 hover-bg-${hoverBg}`}
                        onClick={() => userSignedIn ? setShowCommentForm(!showCommentForm) : toggleRegistration(leadData) }>
                        <i className={`fal me-2 fa-${commentIcon(type)}`}></i>
                        <span className={`fw-bold ${condenseOnMobile && 'd-none d-sm-inline-block'}`}>{capitalizeFirst(postingResponse(type))}</span>
                    </a>
                </Col>
            )
        }
    }

    const renderDownloadPdf = () => {
        if(posting.actions.pdf) {
            const gtmDataAttributes = gtmEventRegion ? {
                'data-gtm-event-region': gtmEventRegion,
                'data-gtm-event-element': 'download'} : {}

            return (
                <Col xs={'auto'} className={'py-2  px-0 px-sm-2'}>
                    <a
                        {...gtmDataAttributes}
                        href={userSignedIn ? posting.actions.pdf : null}
                        target={'_blank'}
                        rel={'nofollow'}
                        className={`p-2 link-secondary font-14 hover-bg-${hoverBg}`}
                        onClick={() => (!userSignedIn && toggleRegistration(leadData))}
                    >
                        <i className={'fal me-2 fa-download'}></i>
                        <span className={`fw-bold ${condenseOnMobile && 'd-none d-sm-inline-block'}`}>Download</span>
                    </a>
                </Col>
            )
        }
    }

    const renderFollowLink = () => {
        if(showFollow && !viewingSelf) {
            return (
                <Col xs={'auto'}  className={'py-2 ms-sm-auto px-0 px-sm-2'}>
                    <Follow
                        item={posting}
                        itemType={'posting'}
                        userSignedIn={userSignedIn}
                        currentUser={currentUser}
                        token={token}
                        hoverBg={hoverBg}
                        condenseOnMobile={condenseOnMobile}
                    />
                </Col>
            )
        }
    }

    const renderLikeLink = () => {
        if(showLikes && !viewingSelf) {
            const gtmDataAttributes = gtmEventRegion ? {
                'data-gtm-event-region': gtmEventRegion,
                'data-gtm-event-element': 'like'} : {}
            return (
                <Col xs={'auto'}  className={'py-2 ms-sm-auto px-0 px-sm-2'}>
                    <Like item={posting}
                          itemLikeUrl={posting.actions.like_url}
                          itemUrl={posting.actions.url}
                          userSignedIn={userSignedIn}
                          currentUser={currentUser}
                          gtmDataAttributes={gtmDataAttributes}
                          token={token}
                          hoverBg={hoverBg}
                          condenseOnMobile={condenseOnMobile}
                          toggleRegistration={toggleRegistration}
                          leadData={leadData}
                    />
                </Col>
            )
        }
    }

    const renderShareLink = () => {
        const gtmDataAttributes = gtmEventRegion ? {
            'data-gtm-event-region': gtmEventRegion,
            'data-gtm-event-element': 'share'} : {}

        return (
            <Col xs={'auto'}  className={`py-2 px-0 px-sm-2`}>
                <Share
                    item={posting}
                    shareObj={posting.actions.share}
                    itemType={'post'}
                    itemUrl={posting.actions.tracking_url}
                    extraContent={posting.title}
                    hoverBg={hoverBg}
                    gtmDataAttributes={gtmDataAttributes}
                    condenseOnMobile={condenseOnMobile} />
            </Col>
        )
    }

    const renderAdminMenu = () => {
        return (
            <Col xs={'auto'} >
                <PostingAdminMenu
                    posting={posting}
                    userSignedIn={userSignedIn}
                    adminUser={adminUser}
                    viewingSelf={viewingSelf}
                    token={token}
                    type={type}
                    toggleRegistration={toggleRegistration}
                    leadData={leadData}
                />
            </Col>
       )

    }

    return (
        <Row className={'justify-content-between align-items-center flex-nowrap mx-0 border-top'}>
            {renderCommentLink()}
            {renderDownloadPdf()}
            {renderFollowLink()}
            {renderLikeLink()}
            {renderShareLink()}
            {renderAdminMenu()}
        </Row>
    )
}
